import type { Id, Item } from './types'

export const removeItem = <T extends Item<Id>>(
  items: T[],
  id: T['id'],
): T[] => {
  return items.filter((item) => item.id !== id)
}

export const removeItems = <T extends Item<Id>>(
  items: T[],
  ids: T['id'][],
): T[] => {
  return items.filter((item) => !ids.includes(item.id))
}
